<ng-template #content><ng-content></ng-content></ng-template>
@if (type === 'link') {
    <app-link [link]="link[0]">
        <button
            (click)="clickHandler($event, false)"
            [ngClass]="additionalClasses"
            class="cursor-pointer">
            <ng-container *ngTemplateOutlet="content"> </ng-container>
        </button>
    </app-link>
}
@if (type === 'button') {
    <button
        (click)="clickHandler($event, true)"
        [disabled]="disabled()"
        [ngClass]="additionalClasses"
        class="cursor-pointer disabled:cursor-not-allowed">
        <ng-container *ngTemplateOutlet="content"> </ng-container>
    </button>
}
